<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <p class="small text-muted">Items marked with <span class="text-danger">*</span> require a response.</p>

        <h6 class="text-muted text-uppercase small mb-2">Job Site</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="job">Job Site <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="meetingDateTime">Date <span class="text-danger">*</span></label>
                    <wj-input-date-time
                        [(ngModel)]="target.meetingDateTime"
                        name="meetingDateTime"
                        id="meetingDateTime"
                        [isRequired]="true"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="jobPhase">Job Phase <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        id="jobPhase"
                        name="jobPhase"
                        [(ngModel)]="target.jobPhase"
                        required
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-12">
                <div class="form-group">
                    <label for="yesterdayInjuryWho">Did anyone on your crew get injured yesterday? If so, who?</label>
                    <app-voice-text-field
                        [(ngModel)]="target.yesterdayInjuryWho"
                        name="yesterdayInjuryWho"
                        inputId="yesterdayInjuryWho"
                        [rows]="2"
                    ></app-voice-text-field>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-check mt-4">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="reportedToSafety"
                        name="reportedToSafety"
                        [(ngModel)]="target.reportedToSafety"
                    />
                    <label class="form-check-label" for="reportedToSafety">Reported to Safety Department on the date of the injury?</label>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Segue</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="segue">Segue <span class="text-danger">*</span></label>
                    <app-voice-text-field [(ngModel)]="target.segue" name="segue" inputId="segue" [rows]="3"></app-voice-text-field>
                    <input type="hidden" name="segueRequired" [ngModel]="target.segue" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="learnedAboutForeman">What did you learn about the Foreman <span class="text-danger">*</span></label>
                    <app-voice-text-field
                        [(ngModel)]="target.learnedAboutForeman"
                        name="learnedAboutForeman"
                        inputId="learnedAboutForeman"
                        [rows]="2"
                    ></app-voice-text-field>
                    <input type="hidden" name="learnedAboutForemanRequired" [ngModel]="target.learnedAboutForeman" required />
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="text-muted text-uppercase small mb-0">What did you learn about the Employee</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addLearnedEmployee()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Employee
            </button>
        </div>
        @if (target.learnedEmployees.length === 0) {
            <p class="text-muted small">No employees added.</p>
        }
        @for (row of target.learnedEmployees; track row.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Employee {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeLearnedEmployee(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group mb-2">
                            <label [for]="'learnedEmployee_' + i">Employee</label>
                            <wj-combo-box
                                [id]="'learnedEmployee_' + i"
                                [name]="'learnedEmployee_' + i"
                                [(ngModel)]="row.employeeHrRef"
                                [itemsSource]="employeeList"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [isRequired]="false"
                            ></wj-combo-box>
                        </div>
                        <div class="col-md-8 form-group mb-2">
                            <label [for]="'learnedAbout_' + i">What did you learn?</label>
                            <app-voice-text-field
                                [(ngModel)]="row.learnedAbout"
                                [name]="'learnedAbout_' + i"
                                [inputId]="'learnedAbout_' + i"
                                [rows]="2"
                            ></app-voice-text-field>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="d-flex align-items-center justify-content-between mb-2 mt-3">
            <h6 class="text-muted text-uppercase small mb-0">Today's Tasks / Task Hazard Assessment</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addTask()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Task
            </button>
        </div>
        @if (target.tasks.length === 0) {
            <p class="text-muted small">No tasks added.</p>
        }
        @for (row of target.tasks; track row.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Task {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeTask(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="form-group mb-2">
                        <label [for]="'taskEmployee_' + i">Employee Name</label>
                        <wj-combo-box
                            [id]="'taskEmployee_' + i"
                            [name]="'taskEmployee_' + i"
                            [(ngModel)]="row.employeeHrRef"
                            [itemsSource]="employeeList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="false"
                        ></wj-combo-box>
                    </div>
                    <div class="form-group mb-2">
                        <label [for]="'taskHazards_' + i">List your hazards for today</label>
                        <app-voice-text-field
                            [(ngModel)]="row.hazards"
                            [name]="'taskHazards_' + i"
                            [inputId]="'taskHazards_' + i"
                            [rows]="2"
                        ></app-voice-text-field>
                    </div>
                    <div class="form-group mb-2">
                        <label [for]="'taskControl_' + i">Control description</label>
                        <app-voice-text-field
                            [(ngModel)]="row.controlDescription"
                            [name]="'taskControl_' + i"
                            [inputId]="'taskControl_' + i"
                            [rows]="2"
                        ></app-voice-text-field>
                    </div>
                    <div class="form-group mb-0">
                        <label [for]="'taskAffected_' + i">Who will be affected by the hazards?</label>
                        <app-voice-text-field
                            [(ngModel)]="row.affectedParties"
                            [name]="'taskAffected_' + i"
                            [inputId]="'taskAffected_' + i"
                            [rows]="2"
                        ></app-voice-text-field>
                    </div>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Safety Topics</h6>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="acknowledgedEmployeeHrRef">Acknowledge an employee for safety this week</label>
                <wj-combo-box
                    [(ngModel)]="target.acknowledgedEmployeeHrRef"
                    name="acknowledgedEmployeeHrRef"
                    id="acknowledgedEmployeeHrRef"
                    [itemsSource]="employeeList"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                ></wj-combo-box>
            </div>
            <div class="col-md-8 form-group">
                <label for="acknowledgedWhy">
                    Why?
                    @if (target.acknowledgedEmployeeHrRef) {
                        <span class="text-danger">*</span>
                    }
                </label>
                <app-voice-text-field
                    [(ngModel)]="target.acknowledgedWhy"
                    name="acknowledgedWhy"
                    inputId="acknowledgedWhy"
                    [rows]="2"
                ></app-voice-text-field>
                @if (target.acknowledgedEmployeeHrRef) {
                    <input type="hidden" name="acknowledgedWhyRequired" [ngModel]="target.acknowledgedWhy" required />
                }
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="safetyTopicThaReview">Safety Topic / Task Hazard Assessment Review <span class="text-danger">*</span></label>
                    <app-voice-text-field
                        [(ngModel)]="target.safetyTopicThaReview"
                        name="safetyTopicThaReview"
                        inputId="safetyTopicThaReview"
                        [rows]="3"
                    ></app-voice-text-field>
                    <input type="hidden" name="safetyTopicThaReviewRequired" [ngModel]="target.safetyTopicThaReview" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="issues">Issues <span class="text-danger">*</span></label>
                    <app-voice-text-field [(ngModel)]="target.issues" name="issues" inputId="issues" [rows]="2"></app-voice-text-field>
                    <input type="hidden" name="issuesRequired" [ngModel]="target.issues" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="issuesResolved">Issues resolved <span class="text-danger">*</span></label>
                    <app-voice-text-field
                        [(ngModel)]="target.issuesResolved"
                        name="issuesResolved"
                        inputId="issuesResolved"
                        [rows]="2"
                    ></app-voice-text-field>
                    <input type="hidden" name="issuesResolvedRequired" [ngModel]="target.issuesResolved" required />
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Signatures</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="foremanSignature">Foreman Signature <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        id="foremanSignature"
                        name="foremanSignature"
                        [(ngModel)]="target.foremanSignature"
                        required
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="foremanSignedOn">Signed On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.foremanSignedOn"
                        name="foremanSignedOn"
                        id="foremanSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2">
            <h6 class="text-muted text-uppercase small mb-0">Employee Signatures</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addSignature()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Signature
            </button>
        </div>
        @if (target.employeeSignatures.length === 0) {
            <p class="text-muted small">No employee signatures added.</p>
        }
        @for (row of target.employeeSignatures; track row.id; let i = $index) {
            <div class="row align-items-end mb-2">
                <div class="col-md-6 form-group mb-0">
                    <label [for]="'empSig_' + i">Employee Signature {{ i + 1 }}</label>
                    <input
                        type="text"
                        class="form-control"
                        [id]="'empSig_' + i"
                        [name]="'empSig_' + i"
                        [(ngModel)]="row.signature"
                    />
                </div>
                <div class="col-md-5 form-group mb-0">
                    <label [for]="'empSignedOn_' + i">Signed On</label>
                    <wj-input-date-time
                        [id]="'empSignedOn_' + i"
                        [name]="'empSignedOn_' + i"
                        [(ngModel)]="row.signedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
                <div class="col-md-1 pb-1">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeSignature(i)">
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
